<template>
  <span class="font-s14 px-2 py-1 d-block text-end fst-italic" :class="classes">
    <img src="/themes/default/images/icons/watch.png" alt="Watch Icon">
    {{ secondsToHms(currentTime) }}
    <br v-if="show_message && time_destroy !== 0"/>
    <strong v-if="show_message && time_destroy !== 0" class="text-danger">Venter på nedtelling</strong>
  </span>
</template>

<script>
export default {
  props: ['time_end', 'time_destroy', 'time', 'classes'],
  data() {
    return {
      timer: null,
      currentTime: 0,
      show_message: false
    }
  },
  mounted() {
    this.startTimer()
  },
  watch: {
    time_end() {
      this.startTimer()
    },
    time() {
      this.startTimer()
    },
  },
  methods: {
    startTimer() {
      this.currentTime = Math.round(Math.round((new Date(this.time_end) - new Date(this.time)) / 1000))
      if (this.currentTime <= this.time_destroy) {
        this.currentTime = this.time_destroy
        this.show_message = true
      } else {
        this.show_message = false
      }
    },
    secondsToHms(d) {
      d = Number(d);
      let days = Math.floor(d / (3600 * 24));
      let h = Math.floor(d % (3600 * 24) / 3600);
      let m = Math.floor(d % (3600 * 24) % 3600 / 60);
      let s = Math.floor(d % (3600 * 24) % 3600 % 60);

      let hDisplay = h > 9 ? (h + ":") : ("0" + h + ":");
      let mDisplay = m > 9 ? (m + ":") : ("0" + m + ":");
      let sDisplay = s > 9 ? (s) : ("0" + s);
      return days + ' dager ' + hDisplay + mDisplay + sDisplay;
    },
  }
}
</script>
